export default "__VITE_ASSET__B6_s8nBL__"